import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import s from './MonetizationPromoStrip.scss';
export const MonetizationPromoStrip = ({ monetizationPromo , className  })=>{
    const { t  } = useTranslation();
    if (![
        'tier',
        'commission',
        'premium_gallery',
        'adoptable'
    ].includes(monetizationPromo)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: monetizationPromo,
        size: 24,
        className: s['badge']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(`avatar.monetizationPromoStrip.var.${monetizationPromo}.body`))));
};
MonetizationPromoStrip.displayName = 'MonetizationPromoStrip';
export default MonetizationPromoStrip;
